import { DataGridProProps, GridValidRowModel, GridRowId } from '@mui/x-data-grid-pro';

import { DataGridProStyled } from './IntakeDataGrid.styled';

const getRowId = <R extends GridValidRowModel = any>(row: R): GridRowId => row.id;

export const IntakeDataGrid = <R extends GridValidRowModel = any>(props: DataGridProProps<R>) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <DataGridProStyled
        hideFooter
        disableColumnMenu
        disableRowSelectionOnClick={false}
        disableMultipleRowSelection={true}
        getRowId={getRowId}
        {...props}
      />
    </div>
  );
};
